import { tuote_fetch } from "../laskuTuote/TuoteFunctions";

export default class tarjousRiviClass {
  constructor(tarjousId, tarjousRiviId = 0) {
    this.otsikko = "TarjousRiviOtsikko";
    this.tarjousId = tarjousId;
    this.tarjousRiviId = tarjousRiviId;
    this.tuoteId = 0;
    this.tuoteIdEval = "";
    this.tuoteNimike = "";
    this.tuote = null;
    this.evalCriteria = "";
    this.evalCriteriaBool = false;
    this.evalSelite = "";
    this.html = "";
    this.htmlEval = "";
    this.maaraEval = "";
    this.maaraEvalNum = 0;
    this.maaraSelite = "";
    this.yksikko = "";
    this.hintaEval = "";
    this.hintaEvalNum = 0;
    this.hintaSelite = "";
    this.alv = 0;
    this.alvSumma = 0;
    this.alvSummaSelite = "";
    this.summa = 0;
    this.summaSelite = "";
    this.alennusProsentti = 0;
    this.alennusSumma = 0;
    this.alennusSelite = "";
    this.luoLaskuRivi = false;
    this.luoTarjousRivi = false;
    this.laskuRiviTxtEval = "";
    this.laskuRiviTxt = "";
    this.yksikko = "";
  }

  initTarjousRivi = async (tarjousRiviJson, token) => {
    if (!tarjousRiviJson) return;
    if (tarjousRiviJson[0]?.tarjousId !== undefined) {
      tarjousRiviJson = tarjousRiviJson[0];
    }
    this.otsikko = tarjousRiviJson.otsikko;
    this.tarjousId = tarjousRiviJson.tarjousId;
    this.tarjousRiviId = tarjousRiviJson.tarjousRiviId;
    this.tuoteId = tarjousRiviJson.tuoteId;
    this.tuoteNimike = tarjousRiviJson.tuoteNimike;
    this.tuoteIdEval = tarjousRiviJson.tuoteIdEval || tarjousRiviJson.tuoteId;
    this.evalCriteria = tarjousRiviJson.evalCriteria;
    this.evalCriteriaBool = tarjousRiviJson.evalCriteriaBool;
    this.evalSelite = tarjousRiviJson.evalSelite;
    this.html = tarjousRiviJson.html;
    this.htmlEval = tarjousRiviJson.htmlEval;
    this.maaraEval = tarjousRiviJson.maaraEval;
    this.maaraEvalNum = tarjousRiviJson.maaraEvalNum;
    this.maaraSelite = tarjousRiviJson.maaraSelite;
    this.yksikko = tarjousRiviJson.yksikko;
    this.hintaEval = tarjousRiviJson.hintaEval;
    this.hintaEvalNum = tarjousRiviJson.hintaEvalNum;
    this.hintaSelite = tarjousRiviJson.hintaSelite;
    this.alv = tarjousRiviJson.alv;
    this.alvSumma = tarjousRiviJson.alvSumma;
    this.alvSummaSelite = tarjousRiviJson.alvSummaSelite;
    this.summa = tarjousRiviJson.summa;
    this.summaSelite = tarjousRiviJson.summaSelite;
    this.alennusProsentti = tarjousRiviJson.alennusProsentti;
    this.alennusSumma = tarjousRiviJson.alennusSumma;
    this.alennusSelite = tarjousRiviJson.alennusSelite;
    this.luoLaskuRivi = tarjousRiviJson.luoLaskuRivi;
    this.luoTarjousRivi = tarjousRiviJson.luoTarjousRivi;
    this.laskuRiviTxtEval = tarjousRiviJson.laskuRiviTxtEval;
    this.laskuRiviTxt = tarjousRiviJson.laskuRiviTxt;
    this.yksikko = tarjousRiviJson.yksikko;
    if (this.tuoteId > 0) {
      const tuoteResult = await tuote_fetch(this.tuoteId, token);
      if (tuoteResult.success) {
        this.tuote = tuoteResult.data;
        if (!this.tuoteIdEval) this.tuoteIdEval = this.tuote.tuoteId.toString();
      } else this.tuote = null;
    }
  };
}
